import { Field } from 'formik';
import { SttInputProtocol } from '@stt-componentes/core';
import { PROTOCOLO } from '../fieldNames';

const Protocolo = ({ strings }) => {

    return (
        <Field name={PROTOCOLO}>
            {({
                field
            }) => (
                <SttInputProtocol
                    label={strings.protocolo}
                    {...field}
                />
            )}
        </Field>
    );
};

export default Protocolo